<template>
    <v-container class="mt-n2 table-container table-container-statistics">
        <item-list :items="projects" :total="total" :itemsPerPage="itemsPerPage" :headers="headers" :bottomText="$t('changed.perPage')" 
            @search="searchInput" @sortBy="getSortedBy" :searchLabel="$t('searchHistory')" :title="$t('statistics')">
        <template slot="tfooter">
            <table-footer :key="footerKey" :page="page" ref="tfooter" :itemSelected="itemsPerPage" :rangeDate="range" :status="startDate" :search="search" :tableInfo="this.$extractions.getProjectsStatisticsPagingInfo" @callback="setRequestInterval" />
        </template>
        </item-list>
        
        <v-container class="total-container">
        <v-layout class="tables">
            <v-row>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('totalByOrganism')}}</p>
                    <v-simple-table class="simple-table">
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{$t('organismWithMoreProjects')}}</td>
                                <td class="text-right table-data"> {{organismMoreProjects}}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('selectAnOrganism')}}</td>
                                <td> 
                                    <v-autocomplete
                                        v-model="organismSelected"
                                        :items="organisms"
                                        class="autocomplete-statistics"
                                        item-text="type"
                                        item-value="value"
                                        @change="getOrganismTotal()"
                                        :label="$t('enterOrSelectOrganism')"
                                    >
                                    <template slot="item" slot-scope="{ item }">
                                        <v-list-item-content class='org-name'>
                                            <v-tooltip bottom class="alert-no-location">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span class="crime-title crimetype-title" v-bind="attrs" v-on="on" >{{item.substring(0,72) }}
                                                        <span v-bind="attrs" v-on="on" v-if="item.length>72"> ...</span>
                                                    </span>
                                                </template>
                                                <span>{{item}}</span><br>
                                            </v-tooltip>
                                        </v-list-item-content>
                                    </template>
                                    </v-autocomplete>
                                </td>
                            </tr>
                            <tr v-if="organismSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjects') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjects }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''">
                                <td class="header-table">{{ $t('totalProjectsStarted') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsStarted }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjectsFinished') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsFinished }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''">
                                <td class="header-table">{{ $t('totalProjectsPreApproved') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsPreApproved }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjectsApproved') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsApproved }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''">
                                <td class="header-table">{{ $t('totalProjectsDenied') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsDenied }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjectsFailed') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsFailed }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''">
                                <td class="header-table">{{ $t('totalProjectsFailedNoRecordings') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsFailedNoRecordings }}</td>
                            </tr>
                            <tr v-if="organismSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjectsExpired') }}</td>
                                <td class="text-right table-data">{{ organismsTotal.totalProjectsExpired }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('totalByTypeOfCrime')}}</p>
                    <v-simple-table class="simple-table simple-table-crimes">
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{$t('typeOfCrimeMostDemandedForExtraction')}}</td>
                                <td class="text-right table-data"> {{crimeTypeMoreProjects}}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('selectACrimeType')}}</td>
                                <td> 
                                    <v-autocomplete
                                        v-model="crimeTypeSelected"
                                        :items="crimeTypeList"
                                        class="autocomplete-statistics"
                                        item-text="type"
                                        item-value="value"
                                        @change="getCrimeType()"
                                        :label="$t('enterOrSelectCrime')"
                                    >
                                    <template slot="item" slot-scope="{}">
                                        <v-menu-content class="prueba">
                                            
                                        </v-menu-content>
                                    </template>
                                    <template slot="item" slot-scope="{ item }">
                                        <v-list-item-content class="crime-name">
                                            <v-tooltip bottom class="alert-no-location">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span class="crime-title crimetype-title" v-bind="attrs" v-on="on" >{{item.substring(0,72) }}
                                                        <span v-bind="attrs" v-on="on" v-if="item.length>72"> ...</span>
                                                    </span>
                                                </template>
                                                <span>{{item}}</span><br>
                                            </v-tooltip>
                                        </v-list-item-content>
                                    </template>
                                    </v-autocomplete>
                                </td>
                            </tr>
                            <tr v-if="crimeTypeSelected != ''" class="gris">
                                <td class="header-table">{{ $t('totalProjects') }}</td>
                                <td class="text-right table-data">{{ crimeType.totalProjects }}</td>
                            </tr>
                            <tr v-if="crimeTypeSelected != ''">
                                <td class="header-table">{{ $t('numberOfCameras') }}</td>
                                <td class="text-right">{{ crimeType.totalCameras }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-layout>
        <p class="min-res">{{$t('minimunResolution')}}</p>
        </v-container>
    </v-container>
</template>

<script>
import StatisticsMixin from '@/mixins/StatisticsMixin'
import FilterMixin from '@/mixins/FilterMixin'
export default {
  components:{
      ItemList: ()=> import('@/components/base/ItemList'),
      TableFooter: ()=>import('@/components/base/TableFooter'),
  },
  mixins: [StatisticsMixin, FilterMixin],
  data () {
    return {
        projects: [],
        sortBy: undefined,
        sortDesc: undefined,
        organismSelected: '',
        crimeTypeSelected: '',
        organismMoreProjects: '',
        crimeTypeMoreProjects:'',
        organisms: [],
        crimeTypeList: [],
        crimeType: [],
        organismsTotal: [],        
        total:{
            totalProjects: 0,
            totalHoursExtracted: 0,
            totalDownloads: 0,
            totalCamerasExtracted: 0
        },
        startDate: '',
        range: 'day',
    }
  },
  props: {
    
  },
  computed:{
      headers: {
        get(){
            return [
                {text: this.$t('projectName'), align: 'start', value: 'projectName'},
                {text: this.$t('crimeType'), align: 'start', value: 'crimeType'},
                {text: this.$t('numberOfCameras'), align: 'start', value: 'totalCameras', sortable: false},
                {text: this.$t('totalHours'), align: 'start', value: 'totalHours', sortable: false},
                {text: this.$t('numberOfDownloads'), align: 'start', value: 'downloadsCount', sortable: false},
                {text: this.$t('requestingOrganism'), align: 'start', value: 'organism', sortable: false},
                {text: this.$t('created'), align: 'start', value: 'creationDate', sortable: false},
                {text: this.$t('resultStatus.PreApproved'), align: 'start', value: 'preApproved', sortable: false},
                {text: this.$t('resultStatus.Approved'), align: 'start', value: 'approved', sortable: false},
                {text: this.$t('resultStatus.Denied'), align: 'start', value: 'denied', sortable: false}
            ]
        }
      },
  },
  watch: {
  },
  created(){
    this.startDate = this.$store.getters.getStartDate
      this.range = this.$store.getters.getRange
      this.getData();
  },
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = 0
  },
  async mounted(){
    await this.setRequestInterval()
    this.getOrganisms() 
    this.getCrimeTypeList()
    this.getOrganismTotal()
    this.getCrimeType()
    
  },
  methods: {
      
    getSortedBy(sortBy, desc){
      this.sortBy = sortBy
      this.sortDesc = desc
      this.setRequestInterval(this.page, this.itemsPerPage)
    },
    async setRequestInterval(page=1, itemsPerPage=10){
      this.page=page
      this.itemsPerPage = itemsPerPage
      if(this.interval!==0)
        clearInterval(this.interval)
      await this.getData()
      this.interval = setInterval(this.getData,30000)
    },
    async getData(){
      await this.$extractions.getStatisticsProjects(this.page,this.itemsPerPage,this.search,this.sortBy, this.sortDesc, this.startDate, this.range).then(response=>{
        if(response.data.length===0){
          if((this.search!=="")&&(this.page===1)){
            this.projects = []    
          }
          if(this.page>1){
            this.page --
            this.$refs.tfooter.stepBack(this.page)
          }else{
            this.$refs.tfooter.stepBack(1)
          }
        } else {
          this.projects = response.data.projects 
          this.total.totalProjects = response.data.totalProjects
          this.total.totalHoursExtracted = response.data.totalHoursExtracted
          this.total.totalDownloads = response.data.totalDownloads
          this.total.totalCamerasExtracted = response.data.totalCamerasExtracted
        }        
      }).catch(()=>{
        
        return null
      })
    },
    searchInput(searched){
      this.page =1
      this.search=searched
      this.footerKey++
      this.setRequestInterval()
      this.getOrganismTotal()
      this.getCrimeType()
    },  
    getOrganisms(){
        this.$extractions.getAllOrganisms().then(response=>{
            var organisms = []
            response.data.forEach(organism => {
                organisms.push(organism.name)
            })
            this.organisms = organisms
        }).catch(e=>{
            console.log('Error: ', e)
        })      
    },
    getCrimeTypeList(){
        this.$extractions.getTypeCrimeList().then(response=>{
            this.crimeTypeList = response.data
        }).catch(e=>{
            console.log('Error: ', e)
        })      
    },
    getCrimeType(){
        this.$extractions.getTypeCrimeTotal(this.search, this.crimeTypeSelected, this.startDate, this.range).then(response=>{
            this.crimeType = response.data
            this.crimeTypeMoreProjects = response.data.crimeTypeMoreProjects
        }).catch(e=>{
            console.log('Error: ', e)
        })      
    },
    getOrganismTotal(){
        this.$extractions.getOrganismTotal(this.search, this.organismSelected, this.startDate, this.range).then(response=>{
            this.organismsTotal = response.data
            this.organismMoreProjects = response.data.organismMoreProjects

        }).catch(e=>{
            console.log('Error: ', e)

        })
    },
    onRefresh(){
        this.getData()
        this.getOrganismTotal()
        this.getCrimeType()
    }
  }
}

</script>
<style>
    
    .tables{
        width: 80%;
        margin: 0 auto;
    }
    .simple-table{
        border: 1px solid #ccc;
    }
    .gris:hover{
        background-color: #f8faff!important;
    }
    .gris{
        background-color: #f8faff!important;
    }
    .header-table{
        font-size: 12px!important;
        font-weight: 600!important;
        width: 60%!important;
        text-align: left!important;
    }
    .autocomplete-statistics .v-label{
        font-size: 9px!important;
    }
    .min-res{
        position: absolute!important;
        font-size: 10px!important;
        text-align: right!important;
        bottom: -35px!important;
        right: 0px!important;
    }
    .crime-name{
        width: 530px!important;
        max-width: 550px!important;
    }
    .org-name{
        width: 500px!important;
        max-width: 550px!important;
    }
    .crime-title{
        display: inline-block!important;
    }
    .icon-dots{
        width: 45px!important;
        max-width: 45px!important;
        margin-top: 5px!important;
        margin-bottom: 0!important;
        padding-bottom: 0!important;
    }
    .crimetype-title{
        max-width: 530px!important;
        width: 530px!important;
    }
    .crimetype-dots{
        max-width: 20px!important;
        width: 20px!important;
    }
    @media (max-width: 700px) {
        .tables{
            width: 100%!important;
        }
        .table-data{
            font-size: 12px!important;
        }
        .autocomplete-statistics input{
            font-size: 12px!important;
        }
        .table-container-statistics .v-application .mx-5{
            margin-left: -20px!important;
        }
    }
    @media (max-width: 450px) {
        .total-container{
            margin-left: -20px!important;
        }
    }
    
</style>